import React from "react";
import logo from "../assets/logo.png"
import { Image } from "@mantine/core";

export default function Logo({height, width} : {height: number, width: number}) {
    return (
          <Image src={logo} height={height} width={width}/>
    )
}